import React from "react";

const Loader = () => {
  return (
    <div className="lds-ring container d-flex justify-content-center aling-item-center">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  );
};

export default Loader;